<span class='title'>Alarmes</span>

<mat-spinner color='primary' [diameter]='20' *ngIf='isLoading$|async'></mat-spinner>

<div *ngIf='!(isLoading$|async)'
     class='clickable'
     (click)='openAlarmWidget()'
     fxLayout='column'
     fxLayoutAlign='center center'
     fxLayoutGap='5px'>
  <div class='colored-circle' [style.backgroundColor]='circleColor$|async'>
    {{summary$|async}}
  </div>
</div>
